import {isAxiosError} from 'axios';
import {api} from '@/lib/api';

export interface CodeOfConductVersion {
    versionId: string;
    version: string;
    locale: 'de' | 'en';
    title: string;
    /** Markdown */
    content: string;
}

export interface CodeOfConductStatus {
    needsConsent: boolean;
    /** The current version, localized; null if the organization has none. */
    version: CodeOfConductVersion | null;
}

export async function getCodeOfConductStatus(orgId: string, locale: string): Promise<CodeOfConductStatus> {
    const xhr = await api.get<CodeOfConductStatus>(`/code-of-conduct/${orgId}/status`, {params: {locale}});
    return xhr.data;
}

export async function acceptCodeOfConduct(orgId: string, versionId: string, locale: string): Promise<{accepted: true}> {
    const xhr = await api.post<{accepted: true}>(`/code-of-conduct/${orgId}/accept`, {versionId, locale});
    return xhr.data;
}

/**
 * True if the accept request was rejected because the accepted version is no longer the
 * current one (HTTP 400, error 'codeOfConductRequired') — the status must be refetched.
 */
export function isCodeOfConductOutdatedError(error: unknown): boolean {
    return isAxiosError(error)
        && error.response?.status === 400
        && (error.response.data as {error?: string} | undefined)?.error === 'codeOfConductRequired';
}
